module.exports = __webpack_public_path__ + "static/media/arrow1.b7d23f73.png";